<!--
 * @Author: DY
 * @Date: 2024-12-05 16:55:29
 * @LastEditTime: 2026-07-01 23:21:54
 * @Description: 物资领用申请表单
 * @FilePath: \ShiMoMobile\src\views\storage\materialRequisitionApplication\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialRequisitionApplicationForm commonFormStyles">
            <HeaderNav
                header-title="物资领用申请表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-tabs animated class="currencyTabsStyle" v-model="activeTab" :scrollspy="false">
                    <van-tab title="申请信息表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请信息表</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="物资领用出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="领用单位"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                                        v-model="formData.ManageOrgName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="领用部门"
                                        placeholder="选择领用部门"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.DeptName"
                                        @click="selectDepartment"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ApplyUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.ApplyTime"
                                    ></van-field>
                                </li>
                                <!-- <li>
                                    <van-field
                                        name="radio"
                                        label="领用类型"
                                        class="fieldRadio"
                                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    >
                                        <template #input>
                                            <van-radio-group v-model="formData.Type" direction="horizontal" :disabled="isDisabled">
                                                <van-radio :name="0" checked-color="#ee0a24">
                                                    备品备件
                                                </van-radio>
                                                <van-radio :name="1" checked-color="#ee0a24">
                                                    办公用品
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li> -->
                                <li>
                                    <van-field
                                        disabled
                                        label="领用部门负责人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ManageName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="部门负责人审核时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.ManageTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                        @click="selectStock"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库管员"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="出库类型"
                                        :placeholder="isDisabled ? '' : '请选择出库类型'"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="formData.OutstockTypeName"
                                        @click="selectOutstockType"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="申请明细表">
                        <div class="formList van-pull-refresh">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请明细表</h5>
                                    <van-icon name="add" v-if="!isDisabled" @click="selectMaterial"></van-icon>
                                </li>
                                <li v-if="formData.Materials.length">
                                    <dl class="materialList" v-for="(item, index) in formData.Materials" :key="`material_${index}`">
                                        <dt>
                                            <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                            <h5>物料代码</h5>
                                            <p>{{ item.MaterialCode }}</p>
                                        </dt>
                                        <dd>
                                            <div>
                                                <p>短描述：</p>
                                                <input type="text" disabled v-model="item.MaterialShortName">
                                            </div>
                                            <div>
                                                <p>长描述：</p>
                                                <input type="text" disabled v-model="item.MaterialName">
                                            </div>
                                            <div>
                                                <p>申请出库数量：</p>
                                                <input type="number" v-model="item.VolumeOutstock" :disabled="isDisabled" @change="volumeOutstockInput(item.Splits[0], item)">
                                            </div>
                                            <div>
                                                <p>单位：</p>
                                                <input type="text" disabled v-model="item.Unit">
                                            </div>
                                            <div @click="selectCostCenter(item)">
                                                <p>成本中心：</p>
                                                <input type="text" readonly v-model="item.CostCenter" :disabled="isDisabled">
                                            </div>
                                            <div>
                                                <p>存放位置：</p>
                                                <input type="text" disabled v-model="item.Splits[0].Location">
                                            </div>
                                            <div>
                                                <p>实际出库量：</p>
                                                <input type="text" disabled v-model="item.Splits[0].VolumePractical">
                                            </div>
                                            <div>
                                                <p>出库前库存：</p>
                                                <input type="text" disabled v-model="item.Splits[0].VolumeBefore">
                                            </div>
                                            <div>
                                                <p>已锁定库存：</p>
                                                <input type="text" disabled v-model="item.Splits[0].VolumeLocked">
                                            </div>
                                            <div>
                                                <p>可用库存：</p>
                                                <input type="text" disabled v-model="item.Splits[0].VolumeAvailable">
                                            </div>
                                            <div>
                                                <p>出库后库存：</p>
                                                <input type="text" disabled v-model="item.Splits[0].VolumeAfter">
                                            </div>
                                        </dd>
                                    </dl>
                                </li>
                                <li class="addMaterialBtn" v-if="(formData.Materials || []).length > 1">
                                    <van-button type="primary" block color="linear-gradient(to right, #ff6034, #ee0a24)" v-if="!isDisabled" @click="selectMaterial">
                                        <van-icon name="add"></van-icon>
                                        <span>添加物料</span>
                                    </van-button>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
                <van-action-sheet title="选择出库类型" v-model="showOutstockType" :actions="outstockTypeList" cancel-text="取消" @select="selectOutstockTypeConfirm" :style="{maxHeight: '50%'}"></van-action-sheet>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button v-if="(formData.Id || '') != ''" @click="deleteApply">
                        删除
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
import { mixin_outboundTypeSelect } from '@/assets/mixin/mixin_outboundTypeSelect';
export default {
    name: 'material-requisition-application-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/materialRequisitionApplication') {
            this.$store.commit('noKeepAlive', 'material-requisition-application-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_MessageJump, mixin_outboundTypeSelect],
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            formData: {
                Id: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                OutstockNumber: '',
                CollectNumber: '',
                ManageOrgId: '',
                ManageOrgName: '',
                DeptId: '',
                DeptName: '',
                ApplyUserId: '',
                ApplyUserName: '',
                ApplyTime: '',
                ManageId: '',
                ManageName: '',
                ManageTime: '',
                Type: 0,
                OutstockUserId: '',
                OutstockUserName: '',
                OutstockTime: '',
                Status: 0,
                Remarks: '',
                AutoIndex: 0,
                MaterialCategory: 1,
                Materials: [],
                OutstockTypeCode: '',
                OutstockTypeName: '',
            },
            Status: '',
            currentMaterial: {},

            material_category: 1,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.department) {
            this.formData.DeptId = this.$route.params.department[0].Dept_Id;
            this.formData.DeptName = this.$route.params.department[0].Dept_Name;
            this.loadManage();
        }
        if (this.$route.params.stock) {
            this.formData.StockId = this.$route.params.stock[0].id;
            this.formData.StockCode = this.$route.params.stock[0].stock_code;
            this.formData.StockName = this.$route.params.stock[0].stock_name;
            this.formData.OutstockUserId = this.$route.params.stock[0].storeman_id;
            this.formData.OutstockUserName = this.$route.params.stock[0].storeman_name;
        }
        if (this.$route.params.costCenter) {
            this.currentMaterial.CostCenter = this.$route.params.costCenter[0].cost_center;
        }
        if (this.$route.params.material) {
            this.$route.params.material.forEach(item => {
                this.formData.Materials.push({
                    StockId: item.stock_id,
                    StockCode: item.stock_code,
                    MaterialCode: item.material_code,
                    MaterialName: item.material_name,
                    MaterialShortName: item.material_short_name,
                    Unit: item.unit,
                    CostCenter: (item.cost_center || '').includes(',') ? '' : item.cost_center,
                    VolumeOutstock: 0,
                    VolumeCurrent: item.volume_current,
                    Splits: [{
                        Id: '',
                        GridId: item.grid_id,
                        GridCode: item.grid_code,
                        GridName: item.grid_name,
                        VolumePractical: null,
                        VolumeLocked: item.volume_locked,
                        VolumeAvailable: NP.minus(item.volume_current || 0, item.volume_locked || 0),
                        VolumeAfter: item.volume_current,
                        VolumeBefore: item.volume_current,
                    }],
                });
            });
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            this.isNews = this.$route.params.isNews || false;
            if (this.isNews && this.$route.params.data.tenant_id) {
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                await this.getNewsToken(this.$route.params.data.tenant_id);
            }
            const type = this.$route.params.type;
            if (type === 'add') {
                this.formData.ManageOrgName = this.$takeTokenParameters('TenantName');
                this.formData.ManageOrgId = this.$takeTokenParameters('TenantId');
                this.formData.DeptId = this.$takeTokenParameters('DeptId');
                this.formData.DeptName = this.$takeTokenParameters('DeptName');
                this.formData.ApplyUserId = this.$takeTokenParameters('Uid');
                this.formData.ApplyUserName = this.$takeTokenParameters('Name');
                this.formData.ApplyTime = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                this.loadManage();
            }
            if (type === 'see') {
                this.isDisabled = true;
            }
            if (type === 'edit' || type === 'see') {
                this.formData = await this.getFormData(this.$route.params.data.id);
            }
            this.Status = this.loadStatus(this.formData.Status);
        },

        loadStatus(nub) {
            const staus = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废', '超期作废'];
            return staus[nub];
        },

        selectDepartment() {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectList',
                params: {
                    relationKey: 'Dept_Id',
                    showFieldName: 'Dept_Name',
                    sourcePath: 'materialRequisitionApplicationForm',
                    listCode: 'choose_dept',
                    callbackDataKey: 'department',
                },
            });
        },

        selectStock() {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'materialRequisitionApplicationForm',
                    listCode: 'outstock_select_stock',
                    callbackDataKey: 'stock',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    pageIndex: 0,
                    initIndex: 0,
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '仓库编号',
                        code: 'stock_no',
                        icon: 'icon_34@2x',
                    }, {
                        name: '位置',
                        code: 'stock_location',
                        icon: 'icon_3@2x',
                    }, {
                        name: '规格',
                        code: 'stock_spec',
                        icon: 'icon_5@2x',
                    }, {
                        name: '类别',
                        code: 'stock_category_str',
                        icon: 'icon_13@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        selectCostCenter(item) {
            if (this.isDisabled) {return;}
            if ((this.formData.DeptId || '') === '') {
                this.$toast.fail('请先选择领用部门！');
                return;
            }
            this.$router.isBack = 2;
            this.currentMaterial = item;
            this.$router.replace({
                name: 'selectList',
                params: {
                    relationKey: 'cost_center',
                    showFieldName: 'cost_center',
                    requestUrl: `/basicplatform/tabledata?dept_id=${this.formData.DeptId}`,
                    sourcePath: 'materialRequisitionApplicationForm',
                    listCode: 'cost_center_select',
                    callbackDataKey: 'costCenter',
                },
            });
        },

        selectMaterial() {
            if ((this.formData.StockId || '') === '') {
                this.$toast.fail('请先选择仓库！');
                return;
            }
            const materialCodes = this.formData.Materials.map(item => item.MaterialCode).join(',');
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择物料',
                    sourcePath: 'materialRequisitionApplicationForm',
                    requestUrl: `/basicplatform/tabledata?stock_id=${this.formData.StockId}&type=${this.formData.Type}&dept_id=${this.formData.DeptId}&material_codes=${materialCodes}`,
                    listCode: 'outstock_select_material',
                    callbackDataKey: 'material',
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '长描述',
                        code: 'material_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '单位',
                        code: 'unit',
                        icon: 'icon_24@2x',
                    }],
                },
            });
        },

        deleteMaterial(index) {
            this.formData.Materials.splice(index, 1);
        },

        async loadManage() {
            const res = await this.getDepartmentHead();
            this.formData.ManageId = res.leader_id;
            this.formData.ManageName = res.leader_name;
        },

        volumeOutstockInput(Splits, item) {
            if (this.isDisabled) {return;}
            // if (item.VolumeOutstock > Splits.VolumeBefore) {
            //     this.$toast.fail('申请出库数量大于当前库存，请重新输入！');
            //     this.$nextTick(() => {
            //         this.$set(item, 'VolumeOutstock', 0);
            //     });
            // } else {
            Splits.VolumeAfter = NP.minus(Splits.VolumeBefore || 0, item.VolumeOutstock || 0);
            // }
        },

        async saveForm() {
            this.$toast.loading({ overlay: true, duration: 0 });
            try {
                // 验证申请出库数量不能为空和零
                const emptyOrZeroMaterials = [];
                for (const item of this.formData.Materials) {
                    const volume = Number(item.VolumeOutstock);
                    if (!item.VolumeOutstock || isNaN(volume) || volume <= 0) {
                        emptyOrZeroMaterials.push(item.MaterialCode);
                    }
                }
                if (emptyOrZeroMaterials.length > 0) {
                    this.$toast.fail(`物料【${emptyOrZeroMaterials.join('、')}】的申请出库数量不能为空或零，请重新输入！`);
                    return;
                }
                // 原有验证逻辑：检查申请出库数量是否大于当前库存
                const materialCode = [];
                this.formData.Materials.forEach(item => {
                    if (Number(item.VolumeOutstock) > Number(item.Splits[0].VolumeBefore)) {
                        materialCode.push(item.MaterialCode);
                    }
                });
                if (materialCode.length > 0) {
                    this.$toast.fail(`物料\n【${materialCode.join('、')}】\n申请出库数量大于当前库存，\n请重新输入！`);
                    return;
                }
                await this.saveFormConfirm();
            } finally {
                this.$toast.clear();
            }
        },

        async saveFormConfirm() {
            const res = await this.saveFormData(this.formData);
            if (res) {
                this.$toast.success('保存成功。');
                this.closeAllocationForm();
            }
        },

        deleteApply() {
            this.$dialog.confirm({
                message: `确认删除出库单 \n【${this.formData.OutstockNumber}】吗？`,
            }).then(async () => {
                const res = await this.deleteRequest(this.formData.Id);
                if (res) {
                    this.$toast('删除成功！');
                    setTimeout(() => {
                        this.closeAllocationForm();
                    }, 1000);
                }
            });
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'materialRequisitionApplication',
                params: {
                    saveCallback: true,
                },
            });
        },

        getDepartmentHead() {
            return this.$axios.$get(`/interfaceApi/basicplatform/depts/${this.formData.DeptId}`, { defEx: true, token: this.newsToken });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock/${id}`, { token: this.newsToken });
        },
        saveFormData(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/outstock/change', requestData, { defEx: true, token: this.newsToken });
        },
        deleteRequest(id) {
            return this.$axios.$delete(`/interfaceApi/procurement/outstock/del/${id}`, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.materialRequisitionApplicationForm
    background #F0F0F0
    section
        height 0
        flex 1
        .van-tabs__content
            .van-tab__pane
                max-height initial
                height 100%
                overflow-y hidden
    .formList
        padding 10rpx
        .formItem
            background #fff
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    &:last-child
                        width 100%
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
</style>
<style lang="stylus">
.addMaterialBtn
    .van-button
        .van-button__text
            font-size 14rpx
            display flex
            align-items center
            gap 0 5rpx
</style>
